export const UPLOAD = 'fileUpload/UPLOAD';
export { TYPE_IMAGE, TYPE_VIDEO } from '../services/request-credentials';

export const upload = (file, name, type, onSuccess) => ({
  type: UPLOAD,
  payload: {
    file,
    name,
    type,
    onSuccess,
  },
});
